module.exports = __webpack_public_path__ + "img/child.c8960f3d.png";